// OpenCodeNet data API (Google Apps Script web app attached to the OpenCodeNet Google Sheet).
// After deploying the script, paste its Web app URL here (it ends in /exec).
export const API_URL = "https://script.google.com/macros/s/AKfycbxW2MlTm4tin6GqgoM21qNReDRFYX_3siF5bXT9QmM5Xk66KHAQVP5hoQQOCOUNm7g/exec";

async function readJson(res) {
  const body = await res.json();
  if (!body.ok) throw new Error(body.error || "Something went wrong.");
  return body.data;
}

async function get(params) {
  const res = await fetch(`${API_URL}?${new URLSearchParams(params)}`);
  return readJson(res);
}

// text/plain avoids a CORS preflight, which Apps Script web apps do not answer.
async function post(action, data) {
  const res = await fetch(API_URL, {
    method: "POST",
    headers: { "Content-Type": "text/plain;charset=utf-8" },
    body: JSON.stringify({ action, data }),
  });
  return readJson(res);
}

export const getUser = (github) => get({ action: "getUser", github });
export const addUser = (github, language) => post("addUser", { github, language });
export const getLabelNames = () => get({ action: "getLabelNames" });
export const addLabelName = (name) => post("addLabelName", { name });
export const getLabels = (label) => get({ action: "getLabels", label });
export const addLabels = (rows) => post("addLabels", rows);
